import { isString, noop } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Icon from '../Icon'

type TWrapper = {
  opacity?: number
  float?: boolean
  showCursor?: boolean
  danger?: boolean
  background?: string
}
type TIconWrapper = {
  float?: boolean
}

type TOverlay = {
  opacity?: number
  children?: React.ReactNode
  icon?: string
  onClick?: () => void
  float?: boolean
  danger?: boolean
  striped?: boolean
}

const Wrapper = styled.div<TWrapper>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({ background }) => background};
  z-index: 2000;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: ${({ float }) => (float ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  cursor: ${({ showCursor }) => (showCursor ? 'pointer' : '')};
`

const IconWrapper = styled.div<TIconWrapper>`
  font-size: 1.2em;
  margin-right: ${({ float }) => (float ? '10px' : '0')};
`

const Overlay = (props: TOverlay): React.ReactElement => {
  const {
    opacity = 0.7,
    children,
    icon = '',
    onClick,
    float = false,
    danger,
    striped,
  } = props

  const background = striped
    ? `repeating-linear-gradient(
    135deg,
    rgba(255, ${danger ? 0 : 255}, ${danger ? 0 : 255}, ${opacity}),
    rgba(255, ${danger ? 0 : 255}, ${danger ? 0 : 255}, ${opacity}) 10px,
    rgba(255, ${danger ? 0 : 255}, ${danger ? 0 : 255}, ${opacity + 0.05}) 10px,
    rgba(255, ${danger ? 0 : 255}, ${danger ? 0 : 255}, ${opacity + 0.05}) 20px
  )`
    : `rgba(
    ${danger ? 255 : 255},
    ${danger ? 250 : 255},
    ${danger ? 250 : 255},
    ${opacity}
  )`

  return (
    <Wrapper
      opacity={opacity}
      onClick={onClick ? onClick : noop}
      showCursor={!!onClick}
      float={float}
      danger={danger}
      background={background}
    >
      {icon && (
        <IconWrapper className="text-muted" float={float}>
          <Icon icon={icon} />
        </IconWrapper>
      )}
      {isString(children) ? (
        <h5 className="text-center">{children}</h5>
      ) : (
        children
      )}
    </Wrapper>
  )
}

export default Overlay
